/**
 * @generated SignedSource<<b4ff6d1a6ef41099a67677e0420efbf4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateOrEditTeamEditMutation$variables = {
  description?: string | null;
  handle?: string | null;
  id: string;
  location?: string | null;
  members?: ReadonlyArray<string> | null;
  parentId?: string | null;
  syncFromExternalGroupId?: string | null;
  syncFromManagerId?: string | null;
  title: string;
};
export type CreateOrEditTeamEditMutation$data = {
  readonly updateTeam: {
    readonly team: {
      readonly archived: boolean;
      readonly description: string | null;
      readonly handle: string | null;
      readonly hasAccess: boolean;
      readonly id: string;
      readonly isAccountWideTeam: boolean;
      readonly location: string | null;
      readonly members: ReadonlyArray<{
        readonly email: string;
        readonly fullName: string;
        readonly hasReceivedInvites: boolean;
        readonly id: string;
        readonly image: string;
        readonly isActive: boolean;
        readonly isConfigured: boolean;
        readonly isTopUser: boolean;
      }>;
      readonly membersCount: number;
      readonly parent: {
        readonly id: string;
        readonly title: string;
      } | null;
      readonly sync: {
        readonly fromExternalGroupId: string | null;
        readonly fromExternalGroupName: string | null;
        readonly fromManager: {
          readonly fullName: string;
          readonly id: string;
        } | null;
        readonly syncFailed: boolean;
      } | null;
      readonly title: string;
    };
  } | null;
};
export type CreateOrEditTeamEditMutation = {
  response: CreateOrEditTeamEditMutation$data;
  variables: CreateOrEditTeamEditMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "description"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "handle"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "location"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "members"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "parentId"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "syncFromExternalGroupId"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "syncFromManagerId"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "title"
},
v9 = [
  {
    "kind": "Variable",
    "name": "description",
    "variableName": "description"
  },
  {
    "kind": "Variable",
    "name": "handle",
    "variableName": "handle"
  },
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  },
  {
    "kind": "Variable",
    "name": "location",
    "variableName": "location"
  },
  {
    "kind": "Variable",
    "name": "members",
    "variableName": "members"
  },
  {
    "kind": "Variable",
    "name": "parentId",
    "variableName": "parentId"
  },
  {
    "kind": "Variable",
    "name": "syncFromExternalGroupId",
    "variableName": "syncFromExternalGroupId"
  },
  {
    "kind": "Variable",
    "name": "syncFromManagerId",
    "variableName": "syncFromManagerId"
  },
  {
    "kind": "Variable",
    "name": "title",
    "variableName": "title"
  }
],
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "members",
  "plural": true,
  "selections": [
    (v10/*: any*/),
    (v13/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "image",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isActive",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isConfigured",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasReceivedInvites",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isTopUser",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "membersCount",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "Team",
  "kind": "LinkedField",
  "name": "parent",
  "plural": false,
  "selections": [
    (v10/*: any*/),
    (v11/*: any*/)
  ],
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "fromManager",
  "plural": false,
  "selections": [
    (v10/*: any*/),
    (v13/*: any*/)
  ],
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fromExternalGroupId",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fromExternalGroupName",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "syncFailed",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "handle",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "location",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "archived",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasAccess",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isAccountWideTeam",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateOrEditTeamEditMutation",
    "selections": [
      {
        "alias": null,
        "args": (v9/*: any*/),
        "concreteType": "UpdateTeamMutation",
        "kind": "LinkedField",
        "name": "updateTeam",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "team",
            "plural": false,
            "selections": [
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TeamSync",
                "kind": "LinkedField",
                "name": "sync",
                "plural": false,
                "selections": [
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/)
                ],
                "storageKey": null
              },
              (v21/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/),
              (v25/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v8/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/),
      (v5/*: any*/),
      (v4/*: any*/),
      (v7/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Operation",
    "name": "CreateOrEditTeamEditMutation",
    "selections": [
      {
        "alias": null,
        "args": (v9/*: any*/),
        "concreteType": "UpdateTeamMutation",
        "kind": "LinkedField",
        "name": "updateTeam",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "team",
            "plural": false,
            "selections": [
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TeamSync",
                "kind": "LinkedField",
                "name": "sync",
                "plural": false,
                "selections": [
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/),
                  (v10/*: any*/)
                ],
                "storageKey": null
              },
              (v21/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/),
              (v25/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "432ab6241d1fcaeb8e2ae7e1e3079bf8",
    "id": null,
    "metadata": {},
    "name": "CreateOrEditTeamEditMutation",
    "operationKind": "mutation",
    "text": "mutation CreateOrEditTeamEditMutation(\n  $id: ID!\n  $title: String!\n  $handle: String\n  $description: String\n  $location: String\n  $parentId: ID\n  $members: [String!]\n  $syncFromManagerId: ID\n  $syncFromExternalGroupId: String\n) {\n  updateTeam(id: $id, title: $title, handle: $handle, description: $description, location: $location, parentId: $parentId, members: $members, syncFromManagerId: $syncFromManagerId, syncFromExternalGroupId: $syncFromExternalGroupId) {\n    team {\n      id\n      title\n      description\n      members {\n        id\n        fullName\n        email\n        image\n        isActive\n        isConfigured\n        hasReceivedInvites\n        isTopUser\n      }\n      membersCount\n      parent {\n        id\n        title\n      }\n      sync {\n        fromManager {\n          id\n          fullName\n        }\n        fromExternalGroupId\n        fromExternalGroupName\n        syncFailed\n        id\n      }\n      handle\n      location\n      archived\n      hasAccess\n      isAccountWideTeam\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9f872e61a0e2ee1dce8ecc82f4df04f5";

export default node;
